import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  select: {
    width     : '55%',
    height    : theme.spacing(20.625)
  },
}));